import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

type ControllerGroup = { label: string; controllers: string[] };

@Component({
  selector: 'app-roles-form',
  templateUrl: './roles-form.component.html',
  styleUrls: ['./roles-form.component.css'],
})
export class RolesFormComponent implements OnInit {
  url: string = 'roles';
  id!: string;
  form: any;
  perms: Array<any> = [];
  selectedPerms: Array<string> = [];

  selectedModuleName: string | null = null;
  currentPerm: any = null;

  controllerGroups: ControllerGroup[] = [
    {
      label: 'Developmet',
      controllers: [
        'users',
        'roles',
        'categories',
        'services',
        'reports',
        'notifications',
        'configs',
        'openai',
        'personnel',
        'accountings',
        'finance',
        'marketing',
        'observability',
        'dashboard',
        'documents',
      ],
    },
    {
      label: 'Finance & Accounting',
      controllers: ['accountings', 'finance', 'dashboard'],
    },
    {
      label: 'Marketing',
      controllers: ['marketing', 'observability', 'dashboard'],
    },
    {
      label: 'Client',
      controllers: [
        'categories',
        'services',
        'reports',
        'notifications',
        'finance',
      ],
    },
    {
      label: 'Driver',
      controllers: ['users', 'services', 'reports', 'finance'],
    },
    {
      label: 'SEO',
      controllers: [
        'seoRegistries',
        'seoMetricsDaily',
        'seoMetricsWeekly',
        'seoActionsBacklog',
        'qaRun',
        'internalLink',
        'seoCannibalClusters',
        'seoCannibalEdges',
        'cannibalization',
        'gbpLocations',
        'gbpReviews',
        'localActions',
        'seoTechnicalAudits',
        'seoSitemapAudits',
        'mediaRoomRegistries',
        'mediaRoomVersions',
        'seoOffpageCampaigns',
        'seoOffpageProspects',
        'seoBacklinks',
        'seoOffpageRecommendations',
        'offPageAttribution',
        'seoKeywordInsights',
        'socialContentRequests',
        'socialRegistries',
        'socialLeads',
        'socialObservability',
        'socialAuditEvents',
        'whatsappCourierSession',
        'seoKeywordDiscoveries'
      ],
    },
  ];

  selectedGroupLabel: string | null = null;
  currentPerms: any[] = []; // módulos (perms) del grupo seleccionado

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      status: [''],
      selectedPerms: [''],
    });

    //selectedPerms: this.fb.array([]),
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  // Llamado cuando cambias el <select>
  onModuleChange(name: string | null) {
    console.log('name en modulo', name);
    this.currentPerm = this.perms.find((p) => p.name === name) || null;
  }

  onGroupChange(label: string | null) {
    this.selectedGroupLabel = label;
    const group = this.controllerGroups.find((g) => g.label === label);
    this.currentPerms = group
      ? this.perms.filter((p) => group.controllers.includes(p.controller))
      : [];
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('esto es respnse perm', response);
      this.form.patchValue({
        name: response.rst.name,
        status: response.rst.status,
      });

      if (response.perms) {
        this.perms = response.perms;
        /* response.perms.forEach((e: any) => {
          if (e.status) {
            this.selectedPerms.push(e.url);
          }
        }); */
        this.selectedPerms = [];
        this.perms.forEach((module) => {
          module.actions.forEach((action) => {
            if (action.status) {
              this.selectedPerms.push(action.url);
            }
          });
        });

        //console.log('esto es selectedPerms', this.selectedPerms);

        this.form.patchValue({
          selectedPerms: this.selectedPerms,
        });

        if (this.perms.length && !this.currentPerm) {
          this.selectedModuleName = this.perms[0].name;
          this.onModuleChange(this.selectedModuleName);
        }

        if (this.controllerGroups.length && !this.selectedGroupLabel) {
          this.onGroupChange(this.controllerGroups[0].label);
        }
      }
    });
  }

  createData(): void {
    this.updateSelectedPerms();
    const formData = {
      ...this.form.value,
      selectedPerms: this.selectedPerms,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('administracion/roles');
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
      selectedPerms: this.selectedPerms,
    };
    console.log('updateData', this.selectedPerms);

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('administracion/roles');
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      });
  }

  /* onCheckChange(event: any) {
    if (event.target.checked) {
      this.selectedPerms.push(event.target.value);
      (this.form.get('selectedPerms') as FormArray).push(
        new FormControl(event.target.value)
      );
    } else {
      this.selectedPerms = this.selectedPerms.filter(
        (x: any) => x != event.target.value
      );
      const formArray = this.form.get('selectedPerms') as FormArray;
      const index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  } */

  toggleModule(perm: any) {
    perm.actions.forEach((a: any) => {
      a.status = perm.status;
    });
    this.updateSelectedPerms();
  }

  toggleAction(perm: any) {
    perm.status = perm.actions.some((a: any) => a.status);
    this.updateSelectedPerms();
  }

  /* updateSelectedPerms() {
    this.form.patchValue({
      selectedPerms: JSON.stringify(this.perms),
    });
  } */

  updateSelectedPerms() {
    this.selectedPerms = [];

    this.perms.forEach((module) => {
      module.actions.forEach((action) => {
        if (action.status) {
          this.selectedPerms.push(action.url);
        }
      });
    });

    this.form.patchValue({
      selectedPerms: this.selectedPerms,
    });
  }
}
